import React, { Component } from "react";
import PropTypes from "prop-types";
//import axios from "axios";

// Util
import Post from "../components/post/Post";
import Profile from "../components/profile/Profile";
import PostSkeleton from "../util/PostSkeleton";
import ProfileSkeleton from "../util/ProfileSkeleton";

import { connect } from "react-redux";
import { getUserData } from "../redux/actions/dataActions";

// Materal UI
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

const styles = (theme) => ({
  ...theme.spreadThis,
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    marginTop: 0,
    marginBottom: 10,
    textAlign: "center",
    color: theme.palette.secondary,
  },
});

class user extends Component {
  state = {
    profile: null,
    postIdParam: null,
  };
  componentDidMount() {
    const handle = this.props.match.params.handle;
    const postId = this.props.match.params.postId;

    if (postId) this.setState({ postIdParam: postId });

    this.props.getUserData(handle);
    // axios
    //   .get(`/user/${handle}`)
    //   .then((res) => {
    //     this.setState({
    //       profile: res.data.user,
    //     });
    //   })
    //   .catch((err) => console.log(err));
  }
  render() {
    console.log(this.props)
    // const { posts, loading } = this.props.data;
    const loading = this.props.UI.loadingProfile;
    const { currentProfile } = this.props.data;
    const { classes } = this.props;
    const { postIdParam } = this.state;
    const posts = currentProfile.posts;
    console.log(posts)
    const postsMarkup = loading || posts === undefined ? (
      <PostSkeleton />
    ) : posts === null || posts.length === 0 ? (
      <div className={styles.root}>
        <Grid container>
          <Paper className={styles.paper}>
            <h4>No posts from this user</h4>
          </Paper>
        </Grid>
      </div>
    ) : !postIdParam ? (
      posts.map((post) => <Post key={post.postId} post={post} />)
    ) : (
      posts.map((post) => {
        if (post.postId !== postIdParam)
          return <Post key={post.postId} post={post} />;
        else return <Post key={post.postId} post={post} openDialog />;
      })
    );

    return (
      <Grid container spacing={3} className={classes.root}>
        <Grid item xs={4}>
          {/* {loading || this.state.profile === null ? ( */}
            {loading || currentProfile === null ? (
            <ProfileSkeleton />
          ) : (
            // <Profile profile={this.state.profile} />
            <Profile profile={currentProfile.user} />
          )}
        </Grid>
        <Grid item xs={8}>
          {postsMarkup}
        </Grid>
      </Grid>
    );
  }
}

user.propTypes = {
  user: PropTypes.object.isRequired,
  getUserData: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  classes: PropTypes.object.isRequired,
  user: state.user,
  data: state.data,
  UI: state.UI,
});

export default connect(mapStateToProps, { getUserData })(user);
